export default function FilterInput({ value, handleFilterChange }) {
  return (
    <input
      type="text"
      placeholder="Type Agency Name"
      value={value}
      onChange={handleFilterChange}
      className="hitq-search-input"
      autoFocus
    />
  );
}
